import { render } from "./userNum.vue?vue&type=template&id=dcbe3e3e"
import script from "./userNum.vue?vue&type=script&lang=js"
export * from "./userNum.vue?vue&type=script&lang=js"

import exportComponent from "G:\\phpstudy_pro\\WWW\\xsr SYETEM\\vue-webagent\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__